'use strict';

angular.module('rmOBA.printManifest', ['ngRoute'])

    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/print_manifest', {
            templateUrl: 'views/print_manifest/print_manifest.html'
        });
    }])

    /**
    * @memberof rmOBA
    * @ngdoc controller
    * @name PrintManifestCtrl
    * @param $scope {service} controller scope
    * @param rmResources {service} Google NavigatorGeolocation wrapper
    * @description 
    *   The View Control for the third and final screen of the app
    */
    .controller('PrintManifestCtrl', [
        '$scope',
        '$location',
        '$modal',
        '$filter',
        '$timeout',
        'rmUtils',
        'rmOrdersUtils',
        'rmResources',
        'rmUserLocationData',
        'rmUserPostalProductsData', function (
            $scope,
            $location,
            $modal,
            $filter,
            $timeout,
            rmUtils,
            rmOrdersUtils,
            rmResources,
            rmUserLocationData,
            rmUserPostalProductsData
        ) {

            // store data before pushing to master
            // if there is local storage use this to populate form
            $scope.user = {};

            /**
            * @memberof PrintManifestCtrl
            * @function getDate
            * @desc Get the current date
            * @returns {string} Current date as srting
            */
            $scope.getDate = function () {
                var d = new Date();
                return d.toDateString();
            }


            // For Barcode generation
            window.setTimeout(function () {
                JsBarcode(
                    "#barcode1", storedUserData['Customer Account Number'] + storedUserData['OBA Posting Location Number'] + "7777777777",
                    {
                        fontSize: 10,
                        background: "#FFFFFF",
                        lineColor: "#000000",
                        margin: 5,
                        displayValue: false,
                        marginLeft: 0,
                        height: 50,
                        width: 1,
                        border: true,
                        borderColor: "#000000",
                    });
            }, 0);


            /**
            * @memberof PrintManifestCtrl
            * @function getTime
            * @desc Get the current time
            * @returns {string} Current time as srting
            */
            $scope.getTime = function () {
                var d = new Date();
                var h = d.getHours();
                var m = d.getMinutes();
                var s = d.getSeconds();

                return h + ':' + m + ':' + s;
            }

            /**
            * @memberof PrintManifestCtrl
            * @function closeModal
            * @desc Close the print manifest modal
            */
            $scope.closeModal = function () {
                $scope.printManifestModal.hide();
            }

            var storedUserData = rmUserLocationData.get();

            if (!_.isEmpty(storedUserData)) {
                $scope.user = storedUserData;
            }


            $scope.orders = [];
            $scope.outputOrdering = {
                orderInCSV: {},
                orderInManifest: {},
                orderInForm: {},
                orderInSummary: {}
            };

            // Get data from local storage
            var storedUserLocationData = rmUserLocationData.get();
            var storedPostalProductData = rmUserPostalProductsData.get();

            if (!_.isEmpty(storedPostalProductData)) {
                $scope.orders = storedPostalProductData;
            }

            if (!_.isEmpty(storedUserLocationData)) {
                $scope.locationData = storedUserLocationData;
            }


            // Get the header names and tidy the orderLines data
            $scope.csvHeaders = rmOrdersUtils.getCSVHeaders($scope.orders);
            $scope.csvOrders = rmOrdersUtils.cleanOrders($scope.orders);


            rmResources.getOrderLinesData().then(function (data) {
                $scope.orderLinesData = data.data;
                // Create Ordering Models
                $scope.orderLinesData.forEach(function (orderLine) {
                    $scope.outputOrdering.orderInCSV[orderLine.Field] = orderLine['Order In CSV'];
                    $scope.outputOrdering.orderInManifest[orderLine.Field] = orderLine['Order In  Manifest'];
                    $scope.outputOrdering.orderInForm[orderLine.Field] = orderLine['Order In  Form'];
                    $scope.outputOrdering.orderInSummary[orderLine.Field] = orderLine['Order In  Summary'];
                });
                $scope.csvOrders = rmOrdersUtils.addLocationData($scope.csvOrders, $scope.orderLinesData, $scope.locationData);

                $scope.manifestOrderLines = rmOrdersUtils.sortOrderLines($scope.csvOrders, $scope.outputOrdering.orderInManifest);
                $scope.manifestOrderHeadings = rmOrdersUtils.orderHeadings($scope.csvHeaders, $scope.outputOrdering.orderInManifest);

                $timeout(function () {
                    window.print();
                }, 750);
            });


            rmUtils.tealiumTagOverlay({
                "pageName": "RM Web App >OBA >Alternative Order Form> 4. Print Manifest",
                "pageMenuTree": "OBA|Alternative Order Form",
                "pageTemplate": "Print Manifest",
                "pageBreadCrumb": "Home|OBA|Alternative Order Form|4. Print Manifest",
                "pageApplicationStep": "4. Print Manifest"
            });

            window.printManifest = $scope;
        }])

